import moment from 'moment'
import { formatBalance } from 'ethtools'

class Utils {
  static thisYear () {
    const m = moment()
    return m.format('YYYY')
  }
  static formatAmount (amt, full) {
    if (!amt) {
      return 'n/a'
    }
    if (!full) {
      return formatBalance(amt, '(0.00 a$)')
    } else {
      return formatBalance(amt)
    }
  }
  static formatTimestamp (ts, fmt) {
    const timestamp = parseInt(ts) * 1000
    const m = moment(timestamp)
    if (fmt) {
      return m.format(fmt)
    } else {
      return m.format('YYYY/MM/DD HH:mm:ss')
    }
    // return new Date(timestamp)
  }
  static fromNow (ts) {
    const timestamp = parseInt(ts) * 1000
    moment.locale('zh-cn')
    const m = moment(timestamp)
    return m.fromNow()
  }
  static addComma (num) {
    return num ? num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : 'n/a'
  }
  static formatAddress (address) {
    // return address ? address.replace('0x', '').toLowerCase() : ''
    return address ? address.toLowerCase() : ''
  }
  static formatHash (hash) {
    // return hash ? hash.replace('0x', '').toUpperCase() : ''
    return hash ? hash.toLowerCase() : ''
  }
  static mayBeAddress (addr) {
    const reg = RegExp('0x[0-9a-fA-F]{40}')
    return reg.test(addr)
  }
  static mayBeHash (addr) {
    const reg = RegExp('0x[0-9a-fA-F]{64}')
    return reg.test(addr)
  }
}

export { Utils as default }



// WEBPACK FOOTER //
// ./src/libs/utils.js